module.exports = __webpack_public_path__ + "img/portTrafficRegulations.4194efcd.svg";